import { faRepeatAlt } from "@fortawesome/pro-regular-svg-icons";

import { toDollars } from "common/utils/formatting";
import Icon from "common/components/Icon";

import { ProductSearchDefaultItem } from "../types";

type ProductSearchAutoshipPricingProps = {
  defaultItem: ProductSearchDefaultItem;
  // The card's CSS module (desktop or mobile) — both define the autoship* classes used here.
  styles: Record<string, string>;
};

/**
 * The autoship line on a search card (desktop + mobile), inline next to the one-time price with
 * the ↻ icon as the separator. Shown only when the item has a subscription price that actually
 * beats the one-time price: "↻ $X with Autoship". Otherwise nothing (every catalog item is
 * subscription-eligible, so an "eligible" tag would show on nearly every card).
 */
const ProductSearchAutoshipPricing = ({
  defaultItem,
  styles,
}: ProductSearchAutoshipPricingProps) => {
  const { subscription_price: subscriptionAmount, standard_price: amount } = defaultItem;
  if (subscriptionAmount == null || subscriptionAmount >= amount) {
    return null;
  }
  return (
    <span className={styles.autoshipLine}>
      <Icon icon={faRepeatAlt} />
      <span className={styles.autoshipStrong}>{toDollars(subscriptionAmount)}</span> with Autoship
    </span>
  );
};

export default ProductSearchAutoshipPricing;
